import React, { useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import InvoiceStatusForm from '../../../components/forms/InvoiceStatusForm';
import { useInvoiceStatusApi } from '../../../hooks/useInvoiceStatusApi';
import { useNavigate } from 'react-router-dom';
import Card from '../../../components/common/Card';
import { InvoiceStatusDTO } from '../../../services/apiClient';

const InvoiceStatusCreate: React.FC = () => {
  const { create, isLoading } = useInvoiceStatusApi();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Invoice Statuses', href: '/admin/invoicestatuses' },
    { label: 'Create', href: '#' },
  ];

  const handleSubmit = async (data: InvoiceStatusDTO) => {
    try {
      await create(data);
      navigate('/admin/invoicestatuses');
    } catch (error) {
      console.error('Error creating InvoiceStatus:', error);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/invoicestatuses"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission="Settings.InvoiceStatus.Edit"
    >
        <InvoiceStatusForm
          initialValues={{} as InvoiceStatusDTO}
          onSubmit={handleSubmit}
          onCancel={() => navigate('/admin/invoicestatuses')}
        />
    </AdminLayout>
  );
};

export default InvoiceStatusCreate;
